const players = new Map();
let activePlayerId = null;

export function registerPlaybackPlayer(player) {
  const id = Symbol("playback-player");
  players.set(id, player);

  return {
    requestPlay() {
      if (activePlayerId && activePlayerId !== id) {
        const activePlayer = players.get(activePlayerId);
        if (activePlayer && typeof activePlayer.pause === "function") {
          activePlayer.pause();
        }
      }

      activePlayerId = id;
    },

    markPaused() {
      if (activePlayerId === id) {
        activePlayerId = null;
      }
    },

    unregister() {
      players.delete(id);
      if (activePlayerId === id) {
        activePlayerId = null;
      }
    },
  };
}
